import api from '@/api/index.js'

const pt_stops = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_PT_STOPS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_PT_STOPS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_PT_STOPS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    },
    SET_PT_STOP_DELETED: (state, deleted) => {
      if (state.data) {
        state.data = state.data.filter(item => item.id != deleted.id);
      }
    },
    SET_PT_STOP_UPDATED: (state, changed) => {
      if (state.data) {
        for (var i in state.data) {
          if (state.data[i].id === changed.id) {
            state.data[i].created_at = changed.created_at;
            state.data[i].updated_at = changed.updated_at;
            state.data[i].stop_id = changed.stop_id;
            state.data[i].name = changed.name;
            state.data[i].zone_id = changed.zone_id;
            state.data[i].municipality_id = changed.municipality_id;
            state.data[i].created_by = changed.created_by;
            state.data[i].modified_by = changed.modified_by;
            state.data[i].info.pavilion = changed.info.pavilion;
            state.data[i].info.voice_tag = changed.info.voice_tag;
            state.data[i].info.digital_display = changed.info.digital_display;
            state.data[i].info.paper_schedule = changed.info.paper_schedule;
            state.data[i].info.metadata = changed.info.metadata;

            break; //Stop this loop, we found it!
          }
        }
      }
    },
  },

  actions: {
    GetPTStops({commit}) {
      commit('SET_PT_STOPS_LOADING', true)
      return api.get('pt-stops?limit=0&offset=0')
        .then((response) => {
          commit('SET_PT_STOPS', response)
          commit('SET_PT_STOPS_LOADING', false)
        })
        .catch((error) => {
          commit('SET_PT_STOPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default pt_stops
